import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store/types";

const getLexBotsState = (state: RootState) => state.lexBots;

export const getLexBotsDataSelector = createSelector(
  [getLexBotsState],
  (s) => s.bots,
);

export const getLexBotsLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.botsLoading,
);

export const getLexIntentsSelector = createSelector(
  [getLexBotsState],
  (s) => s.intents,
);

export const getLexIntentsLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.intentsLoading,
);

export const getLexUtterancesSelector = createSelector(
  [getLexBotsState],
  (s) => s.utterances,
);

export const getLexUtterancesLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.utterancesLoading,
);

export const getLexSlotsSelector = createSelector(
  [getLexBotsState],
  (s) => s.slots,
);

export const getLexSlotsLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.slotsLoading,
);

export const getLexSlotTypesSelector = createSelector(
  [getLexBotsState],
  (s) => s.slotTypes,
);

export const getLexSlotTypesLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.slotTypesLoading,
);

export const getLexSlotTypeDetailSelector = createSelector(
  [getLexBotsState],
  (s) => s.slotTypeDetail,
);

export const getLexSlotTypeDetailLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.slotTypeDetailLoading,
);

export const getLexSlotTypeDetailErrorSelector = createSelector(
  [getLexBotsState],
  (s) => s.slotTypeDetailError,
);

export const getLexMissedUtterancesSelector = createSelector(
  [getLexBotsState],
  (s) => s.missedUtterances,
);

export const getLexMissedUtterancesLoadingSelector = createSelector(
  [getLexBotsState],
  (s) => s.missedUtterancesLoading,
);

export const getLexMissedUtterancesErrorSelector = createSelector(
  [getLexBotsState],
  (s) => s.missedUtterancesError,
);

export const getLexBotsIsErrorSelector = createSelector(
  [getLexBotsState],
  (s) => s.isError,
);

export const getLexBotsErrorMessageSelector = createSelector(
  [getLexBotsState],
  (s) => s.errorMessage,
);
